import React from "react";
import { useLoading } from "../../context/useLoadingContext";
import "./loader.css";

const Loader: React.FC = () => {
  const { isLoading, loadingMessage } = useLoading();

  if (!isLoading) return null;

  return (
    <div className="loader-overlay">
      <div className="loader-container">
        <div className="loader">
          <div className="loader-circle"></div>
          <div className="loader-circle"></div>
          <div className="loader-circle"></div>
        </div>
        {loadingMessage && <p className="loader-message">{loadingMessage}</p>}
      </div>
    </div>
  );
};

export default Loader;
